import React from "react";
import { useTranslation } from "react-i18next";

import AnchorNav, { AnchorItem } from "../../../components/v2/APGM/AnchorNav";
import CompetitionsSection from "../../../components/v2/APGM/CompetitionsSection";
import IdentitySection from "../../../components/v2/APGM/IdentitySection";
import Layout from "../../../components/v2/Layout";
import LawsSection from "../../../components/v2/APGM/LawsSection";
import PageTitle from "../../../components/v2/PageTitle";
import TimelineSection from "../../../components/v2/APGM/TimelineSection";

import aboutImage from "../../../assets/images/apgm/v2/about-pgm.webp";

import style from "./styles.module.scss";

const keyI18n = "translations.aboutPgm";

const anchors: AnchorItem[] = [
  { id: "sobre-a-pgm", labelKey: `${keyI18n}.anchors.about` },
  { id: "identidade-institucional", labelKey: `${keyI18n}.anchors.identity` },
  { id: "linha-do-tempo", labelKey: `${keyI18n}.anchors.timeline` },
  { id: "historico-de-concursos", labelKey: `${keyI18n}.anchors.competitions` },
  { id: "leis-complementares", labelKey: `${keyI18n}.anchors.laws` },
];

export default function APGM() {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${keyI18n}.title`)}>
      <div className={style.body}>
        <div className={style.main}>
          <section className={style.about} id="sobre-a-pgm">
            <PageTitle
              subtitle={t(`${keyI18n}.subtitle`)}
              title={t(`${keyI18n}.title`)}
            />
            <p className={`pgm-body-large ${style.text}`}>
              {t(`${keyI18n}.intro1`)}
            </p>
            <img
              alt={t(`${keyI18n}.imageAlt`)}
              className={style.image}
              decoding="async"
              src={aboutImage}
            />
            <p className={`pgm-body-large ${style.text}`}>
              {t(`${keyI18n}.intro2`)}
            </p>
          </section>

          <IdentitySection />
          <TimelineSection />
          <CompetitionsSection />
          <LawsSection />
        </div>

        <AnchorNav items={anchors} />
      </div>
    </Layout>
  );
}
